function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Gender_sex_Female_male",
  "data-name": "Gender, sex, Female, male"
}, React.createElement("path", {
  d: "M29,18a18.49,18.49,0,0,0-1.5,36.92V70h-8a1.5,1.5,0,0,0,0,3h8v7.5a1.5,1.5,0,0,0,3,0V73h8a1.5,1.5,0,0,0,0-3h-8V54.92A18.49,18.49,0,0,0,29,18Zm0,34A15.5,15.5,0,1,1,44.5,36.5,15.51,15.51,0,0,1,29,52Z"
}), React.createElement("path", {
  d: "M72.5,45.08V22.62l6.94,6.94a1.5,1.5,0,0,0,2.12,0,1.49,1.49,0,0,0,0-2.12l-9-9a1.45,1.45,0,0,0-1.24-.4,1.3,1.3,0,0,0-.64,0,1.45,1.45,0,0,0-1.24.4l-9,9a1.49,1.49,0,0,0,0,2.12,1.5,1.5,0,0,0,2.12,0l6.94-6.94V45.08a18.5,18.5,0,1,0,3,0ZM71,79A15.5,15.5,0,1,1,86.5,63.5,15.51,15.51,0,0,1,71,79Z"
}));

var SvgGender = function SvgGender(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGender, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gender.dfdab589.svg";
export { ForwardRef as ReactComponent };